/// <reference path="../../node_modules/bingmaps/types/MicrosoftMaps/Microsoft.Maps.d.ts" />
/// <reference path="../../node_modules/bingmaps/types/MicrosoftMaps/Modules/Search.d.ts" />
/// <reference path="../../node_modules/bingmaps/types/MicrosoftMaps/Modules/SpatialMath.d.ts" />
/// <reference path="../../node_modules/bingmaps/types/MicrosoftMaps/Modules/SpatialDataService.d.ts" />import { Promise } from "es6-promise";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var MapImpl = /** @class */ (function () {
    function MapImpl(module, native) {
        this.module = module;
        this.native = native;
    }
    MapImpl.prototype.getSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            var module, native;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getSearch(this.module)];
                    case 1:
                        module = _a.sent();
                        native = new module.SearchManager(this.native);
                        return [2 /*return*/, new SearchImpl(module, native, this)];
                }
            });
        });
    };
    MapImpl.prototype.getSpatialData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var module;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getSpatialData(this.module)];
                    case 1:
                        module = _a.sent();
                        return [2 /*return*/, new SpatialDataImpl(module, this)];
                }
            });
        });
    };
    MapImpl.prototype.getSpatialMath = function () {
        return __awaiter(this, void 0, void 0, function () {
            var module;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getSpatialMath(this.module)];
                    case 1:
                        module = _a.sent();
                        return [2 /*return*/, new SpatialMathImpl(module, this)];
                }
            });
        });
    };
    MapImpl.prototype.addCurrentLocationPushpin = function (location) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var position;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!location) return [3 /*break*/, 2];
                        return [4 /*yield*/, getCurrentLocation()];
                    case 1:
                        position = _a.sent();
                        if (position) {
                            location = new this.module.Location(position.coords.latitude, position.coords.longitude);
                        }
                        _a.label = 2;
                    case 2:
                        this.currentLocation = location;
                        if (!this._currentLocationPushpinLayer) {
                            this._currentLocationPushpinLayer = new this.module.Layer("Current Location");
                            this.native.layers.insert(this._currentLocationPushpinLayer);
                        }
                        this._currentLocationPushpinLayer.clear();
                        if (location) {
                            this._currentLocationPushpinLayer.add(this.createFontPushpin(location, '\uF041', undefined, undefined, "blue", function (size) { return new _this.module.Point(size.width / 2, size.height); }));
                        }
                        return [2 /*return*/, location];
                }
            });
        });
    };
    MapImpl.prototype.addPushpin = function (location, options, infoboxOptions) {
        var _this = this;
        if (!this._pushpinLayer) {
            this._pushpinLayer = new this.module.Layer("Pushpins");
            this.native.layers.insert(this._pushpinLayer);
        }
        var pin = new this.module.Pushpin(location, __assign({}, options, { enableHoverStyle: true }));
        this._pushpinLayer.add(pin);
        if (infoboxOptions) {
            this.module.Events.addHandler(pin, "mouseover", function () {
                _this.showInfobox(location, infoboxOptions);
            });
        }
        return pin;
    };
    MapImpl.prototype.clearPushpins = function () {
        this._pushpinLayer && this._pushpinLayer.clear();
    };
    MapImpl.prototype.resetView = function () {
        this.hideInfobox();
        this._currentLocationPushpinLayer && this._currentLocationPushpinLayer.dispose();
        this._currentLocationPushpinLayer = undefined;
        this.clearPushpins();
        this.native.setView({
            mapTypeId: this.module.MapTypeId.road,
            center: new this.module.Location(39.8283, -98.5795),
            zoom: 5
        });
    };
    MapImpl.prototype.setViewToAll = function (locations) {
        locations = locations || (this._pushpinLayer ? this._pushpinLayer.getPrimitives().map(function (p) { return p.getLocation(); }) : []).concat([
            this.currentLocation
        ]).filter(function (p) { return p; });
        if (locations.length === 1) {
            this.native.setView({
                center: locations[0],
                zoom: 10
            });
        }
        else if (locations.length !== 0) {
            this.native.setView({ bounds: this.module.LocationRect.fromLocations(locations) });
        }
    };
    MapImpl.prototype.showInfobox = function (location, options) {
        if (!this._infobox) {
            this._infobox = new this.module.Infobox(new this.module.Location(0, 0), { visible: false });
            this._infobox.setMap(this.native);
        }
        this._infobox.setLocation(location);
        this._infobox.setOptions(__assign({}, options, { visible: true }));
    };
    MapImpl.prototype.hideInfobox = function () {
        if (!this._infobox)
            return;
        this._infobox.setOptions({ visible: false });
    };
    MapImpl.prototype.createFontPushpin = function (location, text, fontName, fontSizePx, color, anchorFn) {
        var _this = this;
        if (fontName === void 0) { fontName = "FontAwesome"; }
        if (fontSizePx === void 0) { fontSizePx = 30; }
        if (color === void 0) { color = "red"; }
        anchorFn = anchorFn || (function (size) { return new _this.module.Point(size.width / 2, size.height / 2); });
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var font = fontSizePx + 'px ' + fontName;
        context.font = font;
        //Resize canvas based on sie of text.
        var size = context.measureText(text);
        canvas.width = size.width;
        canvas.height = fontSizePx;
        //Reset font as it will be cleared by the resize.
        context.font = font;
        context.textBaseline = 'top';
        context.fillStyle = color;
        context.fillText(text, 0, 0);
        return new this.module.Pushpin(location, {
            icon: canvas.toDataURL(),
            anchor: anchorFn({ width: canvas.width, height: canvas.height })
        });
    };
    MapImpl.prototype.dispose = function () {
        this.native.dispose();
        this._currentLocationPushpinLayer && this._currentLocationPushpinLayer.dispose();
        this._pushpinLayer && this._pushpinLayer.dispose();
    };
    return MapImpl;
}());
var SearchImpl = /** @class */ (function () {
    function SearchImpl(module, native, map) {
        this.module = module;
        this.native = native;
        this._map = map;
    }
    SearchImpl.prototype.geocode = function (line1OrWhere, city, state, zip) {
        var _this = this;
        var where = line1OrWhere && city && state && zip
            ? line1OrWhere + ", " + city + ", " + state + " " + zip
            : line1OrWhere;
        var bounds = this._map.native.getBounds();
        bounds.height = bounds.height === 0 ? 1 : bounds.height;
        bounds.width = bounds.width === 0 ? 1 : bounds.width;
        return new Promise(function (resolve, reject) {
            _this.native.geocode({
                bounds: bounds,
                where: where,
                callback: function (result) { return resolve(result); },
                errorCallback: function (options) { return reject(options); }
            });
        });
    };
    return SearchImpl;
}());
// https://msdn.microsoft.com/en-us/library/hh478191.aspx
var itemTypes = {
    "Airport": 4581,
    "Amusement Park": 7996,
    "Animal Park": 9718,
    "ATM": 3578,
    "Auto Dealerships": 5511,
    "Auto Dealership-Used Cars": 5512,
    "Auto Service & Maintenance": 7538,
    "Automobile Club": 8699,
    "Bank": 6000,
    "Bookstore": 9995,
    "Border Crossing": 9999,
    "Bowling Centre": 7933,
    "Bus Station": 4170,
    "Business Facility": 5000,
    "Campground": 9517,
    "Cargo Centre": 9714,
    "Casino": 7985,
    "Cemetery": 9591,
    "Cinema": 7832,
    "City Hall": 9121,
    "Civic/Community Centre": 7994,
    "Clothing Store": 9537,
    "Coffee Shop": 9996,
    "Commuter Rail Station": 4100,
    "Consumer Electronics Store": 9987,
    "Convenience Store": 9535,
    "Convention/Exhibition Centre": 7990,
    "County Council": 9994,
    "Court House": 9211,
    "Department Store": 9545,
    "Embassy": 9993,
    "Ferry Terminal": 4482,
    "Golf Course": 7992,
    "Government Office": 9525,
    "Grocery Store": 5400,
    "Hamlet": 9998,
    "Higher Education": 8200,
    "Highway Exit": 9592,
    "Historical Monument": 5999,
    "Home Improvement & Hardware Store": 9986,
    "Home Specialty Store": 9560,
    "Hospital": 8060,
    "Hotel": 7011,
    "Ice Skating Rink": 7998,
    "Industrial Zone": 9991,
    "Library": 8231,
    "Marina": 4493,
    "Medical Service": 9583,
    "Military Base": 9715,
    "Motorcycle Dealership": 5571,
    "Museum": 8410,
    "Named Place": 4444,
    "Nightlife": 5813,
    "Office Supply & Services Store": 9988,
    "Other Accommodation": 7013,
    "Park & Ride": 7522,
    "Park/Recreation Area": 7947,
    "Parking Garage/House": 7521,
    "Parking Lot": 7520,
    "Performing Arts": 7929,
    "Petrol/Gasoline Station": 5540,
    "Pharmacy": 9565,
    "Place of Worship": 9992,
    "Police Station": 9221,
    "Post Office": 9530,
    "Public Sports Airport": 4580,
    "Rental Car Agency": 7510,
    "Residential Area/Building": 9590,
    "Rest Area": 7897,
    "Restaurant": 5800,
    "School": 8211,
    "Shopping": 6512,
    "Ski Lift": 7014,
    "Ski Resort": 7012,
    "Specialty Store": 9567,
    "Sporting Goods Store": 9568,
    "Sports Centre": 7997,
    "Sports Complex": 7940,
    "Tourist Attraction": 7999,
    "Tourist Information": 7389,
    "Train Station": 4013,
    "Transportation Service": 9593,
    "Truck Dealership": 9719,
    "Truck Stop/Plaza": 9522,
    "Weigh Station": 9710,
    "Winery": 2084
};
var SpatialDataImpl = /** @class */ (function () {
    function SpatialDataImpl(module, map) {
        this.module = module;
        this._map = map;
    }
    SpatialDataImpl.prototype.nearby = function (term, radius) {
        var _this = this;
        if (radius === void 0) { radius = 25; }
        return new Promise(function (resolve, reject) {
            _this.module.QueryAPIManager.search({
                queryUrl: "//spatial.virtualearth.net/REST/v1/data/f22876ec257b474b82fe2ffcb8393150/NavteqNA/NavteqPOIs",
                filter: "EntityTypeID eq '" + itemTypes[term] + "'",
                inlineCount: true,
                spatialFilter: {
                    spatialFilterType: "nearby",
                    location: _this._map.currentLocation,
                    radius: radius
                }
            }, _this._map.native, function (data, inlineCount) {
                resolve({ data: data, total: inlineCount });
            }, undefined, function (networkStatus, statusMessage) {
                reject(statusMessage);
            });
        });
    };
    return SpatialDataImpl;
}());
var SpatialMathImpl = /** @class */ (function () {
    function SpatialMathImpl(module, map) {
        this.module = module;
        this._map = map;
    }
    SpatialMathImpl.prototype.getDistanceTo = function (origin, destination, units, highAccuracy) {
        return this.module.getDistanceTo(origin, destination, units, highAccuracy);
    };
    return SpatialMathImpl;
}());
export function create(apiKey, parentElement, scriptSrc) {
    return __awaiter(this, void 0, void 0, function () {
        var module, native, map;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getModule(scriptSrc)];
                case 1:
                    module = _a.sent();
                    native = new module.Map(parentElement, {
                        credentials: apiKey,
                        mapTypeId: module.MapTypeId.road,
                        navigationBarMode: module.NavigationBarMode.compact
                    });
                    map = new MapImpl(module, native);
                    map.resetView();
                    return [2 /*return*/, map];
            }
        });
    });
}
// =======================================================
// Helpers
// =======================================================
var _cachedCurrentLocation;
function getCurrentLocation() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    if (_cachedCurrentLocation) {
                        resolve(_cachedCurrentLocation);
                    }
                    navigator.geolocation.getCurrentPosition(function (position) {
                        _cachedCurrentLocation = position;
                        resolve(_cachedCurrentLocation);
                    }, function (error) {
                        if (error.code === error.PERMISSION_DENIED) {
                            resolve(undefined);
                        }
                        else {
                            reject(error);
                        }
                    });
                })];
        });
    });
}
// =======================================================
// Module initialization
// =======================================================
var initalizeCallbackName = "__helpers_BingMaps_initialize__";
var getModulePromise;
function getModule(src) {
    if (getModulePromise)
        return getModulePromise;
    src = src || "//www.bing.com/api/maps/mapcontrol?branch=release";
    src += src.indexOf('?') === -1
        ? '?'
        : '&';
    src += "callback=" + initalizeCallbackName;
    return getModulePromise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = src;
        script.onerror = function () {
            reject("Could not load script '" + src + "'");
        };
        window[initalizeCallbackName] = function () {
            window[initalizeCallbackName] = undefined;
            if (!window.Microsoft || !window.Microsoft.Maps) {
                reject("Error parsing script '" + src + "'");
                return;
            }
            resolve(window.Microsoft.Maps);
        };
        document.body.appendChild(script);
    });
}
var getSearchPromise;
function getSearch(module) {
    if (getSearchPromise)
        return getSearchPromise;
    return getSearchPromise = new Promise(function (resolve, reject) {
        module.loadModule("Microsoft.Maps.Search", {
            callback: function () { return resolve(window.Microsoft.Maps.Search); },
            errorCallback: function () { return reject("Could not load 'Microsoft.Maps.Search'"); }
        });
    });
}
var getSpatialDataPromise;
function getSpatialData(module) {
    if (getSpatialDataPromise)
        return getSpatialDataPromise;
    return getSpatialDataPromise = new Promise(function (resolve, reject) {
        module.loadModule("Microsoft.Maps.SpatialDataService", {
            callback: function () { return resolve(window.Microsoft.Maps.SpatialDataService); },
            errorCallback: function () { return reject("Could not load 'Microsoft.Maps.SpatialDataService'"); }
        });
    });
}
var getSpatialMathPromise;
function getSpatialMath(module) {
    if (getSpatialDataPromise)
        return getSpatialMathPromise;
    return getSpatialMathPromise = new Promise(function (resolve, reject) {
        module.loadModule("Microsoft.Maps.SpatialMath", {
            callback: function () { return resolve(window.Microsoft.Maps.SpatialMath); },
            errorCallback: function () { return reject("Could not load 'Microsoft.Maps.SpatialMath'"); }
        });
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/Helpers/BingMaps.ts
// module id = 264
// module chunks = 0 1 5